import { useState, useEffect } from 'react'
import { Menu } from 'lucide-react'
import { navigation } from '../../data/navigation'
import { MobileMenu } from '../ui/MobileMenu'
import { Button } from '../ui/Button'
import { trackNavigation, trackCTA } from '../../lib/firebase'

export function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [isScrolled, setIsScrolled] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20)
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    // Check if we're on a light background page (not home with hero)
    const isLightPage = typeof window !== 'undefined' &&
        (window.location.pathname === '/politica-privacidade' ||
            window.location.hash === '#politica-privacidade')

    // Use scrolled styles when scrolled OR on a light background page
    const useDarkStyle = isScrolled || isLightPage

    return (
        <>
            <header
                className={`
          fixed top-0 left-0 right-0 z-30 transition-all duration-300
          ${useDarkStyle
                        ? 'bg-white/95 backdrop-blur-sm shadow-md py-3'
                        : 'bg-transparent py-5'
                    }
        `}
            >
                <div className="container-section">
                    <div className="flex items-center justify-between">
                        {/* Logo */}
                        <a href="/" className="flex items-center gap-2 relative z-10">
                            <img
                                src="/assets/logo-dpxp-it-solutions-colorido.svg"
                                alt="DPXP IT Solutions"
                                className={`h-14 w-auto transition-all duration-300 ${useDarkStyle ? '' : 'brightness-0 invert'
                                    }`}
                            />
                        </a>

                        {/* Desktop Navigation */}
                        <nav className="hidden lg:flex items-center gap-8">
                            {navigation.map((item) => (
                                <a
                                    key={item.href}
                                    href={`/${item.href}`}
                                    className={`
                    font-medium transition-colors hover:text-dpxp-accent
                    ${useDarkStyle ? 'text-dpxp-dark' : 'text-white'}
                  `}
                                    onClick={() => trackNavigation(item.href, 'header')}
                                >
                                    {item.label}
                                </a>
                            ))}
                        </nav>

                        {/* Desktop CTA */}
                        <div className="hidden lg:block">
                            <Button href="/#contato" variant="primary" size="sm" onClick={() => trackCTA('fale_com_especialista', 'header')}>
                                Fale com um Especialista
                            </Button>
                        </div>

                        {/* Mobile Menu Button */}
                        <button
                            onClick={() => setIsMenuOpen(true)}
                            className={`
                lg:hidden p-2 rounded-lg transition-colors
                ${useDarkStyle
                                    ? 'text-dpxp-dark hover:bg-gray-100'
                                    : 'text-white hover:bg-white/10'
                                }
              `}
                            aria-label="Abrir menu"
                        >
                            <Menu className="w-6 h-6" />
                        </button>
                    </div>
                </div>
            </header>

            {/* Mobile Menu */}
            <MobileMenu
                isOpen={isMenuOpen}
                onClose={() => setIsMenuOpen(false)}
            />
        </>
    )
}
